import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sun, Lock, ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, setToken } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success(`Bienvenue ${data.user.name} !`);
      navigate("/agenda");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Connexion impossible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-primary px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md rounded-3xl border border-border bg-card p-8 shadow-2xl"
      >
        <div className="mb-6 flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent text-accent-foreground">
            <Lock className="h-5 w-5" />
          </span>
          <div>
            <h1 className="font-display text-xl font-bold">Espace privé</h1>
            <p className="text-sm text-muted-foreground">Agenda réservé à l'administrateur</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="mb-1.5 block text-sm">Email</Label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" placeholder="euroconsult.eu@gmail.com" required />
          </div>
          <div>
            <Label className="mb-1.5 block text-sm">Mot de passe</Label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" placeholder="••••••••" required />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="h-12 w-full rounded-full bg-accent text-base hover:bg-accent/90">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Se connecter"}
          </Button>
        </form>
        <Link to="/" className="mt-6 flex items-center justify-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-accent" data-testid="login-back-link">
          <ArrowLeft className="h-4 w-4" /> Retour au site
        </Link>
      </motion.div>
      <div className="pointer-events-none absolute left-6 top-6 flex items-center gap-2 font-display text-lg font-bold text-primary-foreground">
        <Sun className="h-5 w-5 text-accent" /> Solaria
      </div>
    </div>
  );
}
